import PropTypes from 'prop-types';

const HeroSection = ({data}) => {
  return (
    <div className={'w-full h-full lg:mt-4 '}>
      <img src={data.image} alt={'herosection'} className={'w-full h-full object-cover lg:pt-0 pt-5 '}></img>
    </div>
  );
};

HeroSection.propTypes = {
  data: PropTypes.shape,
};

export default HeroSection;
